import SignaturePad from 'signature_pad';

var signatureCapture = (function () {
    'use strict';

    var canvas;
    var hiddenSignatureDataInput;
    var hiddenSignatureImage;
    var signaturePad;


    function init() {
        canvas = document.getElementById('signatureCanvas');
        hiddenSignatureDataInput = document.getElementById('SignatureData');
        hiddenSignatureImage = document.getElementById('SignatureImage');
        var clearBtn = document.getElementById('clearSignatureBtn');

        if (!canvas || !hiddenSignatureDataInput) return;

        signaturePad = new SignaturePad(canvas);
        signaturePad.addEventListener("endStroke", save);

        var form = document.querySelector('form');
        if (form) {
            form.addEventListener('submit', saveAndSubmit);
        }

        if (clearBtn) {
            clearBtn.addEventListener('click', clearPad);
        }

        resizeCanvas();

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(resizeCanvas, 200);
        });

        if (hiddenSignatureDataInput.value) {
            try {
                const data = JSON.parse(hiddenSignatureDataInput.value);
                signaturePad.fromData(data);
            } catch (e) {
                console.error('Failed to restore signature', e);
            }
        }
    }

    function resizeCanvas() {
        if (!canvas || !signaturePad) return;

        const data = signaturePad.toData();
        var devicePixelRatio = window.devicePixelRatio;
        var ratio = Math.max(devicePixelRatio || 1, 1);

        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;

        const ctx = canvas.getContext('2d');
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.scale(ratio, ratio);

        signaturePad.fromData(data);
        console.log("devicePixelRatio: " + devicePixelRatio);
        console.log("canvas offsetWidth: " + canvas.offsetWidth);
        console.log("canvas offsetHeight: " + canvas.offsetHeight);
    }

    function clearPad() {
        if (signaturePad) {
            signaturePad.clear();
            hiddenSignatureDataInput.value = "";
            hiddenSignatureImage.value = "";
        }
    }

    function saveAndSubmit() {
        if(!hiddenSignatureDataInput.value){
            save();
        }
        return true;
    }
    function save() {

        if (signaturePad && !signaturePad.isEmpty()) {
            hiddenSignatureDataInput.value = JSON.stringify(signaturePad.toData());
            hiddenSignatureImage.value = signaturePad.toDataURL();
        } else {
            console.warn("Signature pad is empty or uninitialized.");
            hiddenSignatureDataInput.value = "";
            hiddenSignatureImage.value = "";
        }

        return true;
    }

    return {
        init: init,
        clear: clearPad
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    signatureCapture.init();
});
